import gql from 'graphql-tag';

const FRAGMENTS = gql`
  fragment User on users {
    user_email
    user_phone
    user_first_name
    user_id
    user_last_name
    user_cognito_sub
    user_pic
    gender
    gender_pronounce
    state
  }
  fragment StudentMilestoneExercise on student_milestone_exercises {
    completed_at
    due_date
    exercise_id
    id
    user_id  
    response  
    status  
    student_milestone {
        id
        name
    }  
    exercise {
      id
      name
      description
      type
      meeting_type  
      module {
          id
          name
      }  
    }
  }
`;

export const GET_FA_STUDENTS = gql`
  query getFaStudents($user_id: Int!, $date: date) {
    students: v_students(
      where: {
        _and: [
          { fa_id: { _eq: $user_id } }
          {
            _or: [
              { is_trial: { _eq: false } }
              { is_trial: { _is_null: true } }
              { trial_end_date: { _gte: $date } }
            ]
          }
        ]
      }
    ) {
      user_email
      user_first_name
      user_id
      user_last_name
      name  
      hc_name
      hc_id
      user_cognito_sub
      graduation_year
      user_pic
      product_type
      has_active_subscription
      group_student {
        id
        group_id
        group {
          name
        }
    }
    subscriptions(where: { end_date : { _gte : $date }  }) {
      end_date
    }
    }
  }
`;

export const GET_STUDENT = gql`
  query student($user_id: Int!) {
      users: v_students(where: { user_id: { _eq: $user_id } }) {
          user_email
          user_phone
          user_first_name
          user_id
          user_last_name
          user_cognito_sub
          user_pic
          gender_pronounce
          timezone
          gender
          state
          lc_id
          hc_id
          fa_id
          group: group_student {
              id
              group_id
          }
          profile: student_profile {
              financial_aid_settings
          }
          guardians {
              guardian {
                  user_first_name
                  user_last_name
                  user_email
              }
          }
      }
  }
  ${FRAGMENTS}
`;

export const GET_FA_EXERCISES = gql`
  query getFaExercises($userId: Int!) {
    rows: student_milestone_exercises(
      where: {
        user_id: { _eq: $userId }
        exercise: { meeting_type: { _eq: "fa" } }
      },
        order_by: [{exercise: {module: {order: asc }}}]
    ) {
      ...StudentMilestoneExercise
    }
  }
  ${FRAGMENTS}
`;
